import { makeStyles } from "@material-ui/core";
import { container } from "assets/jss/realtimeWidget.js";

const carouselStyle = makeStyles((theme) => ({
  section: {
    padding: "70px 0 20px 0"
  },
  container,
  carouselGrid: {
    maxWidth: "750px",
    marginLeft: "auto !important",
    marginRight: "auto !important"
  },
  "@global": {
    '.slick-dots li.slick-active button:before': {
      backgroundColor: theme.palette.primary.main
    }
  }
}));

export default carouselStyle;
